import React, { useState } from 'react';
import { Container } from '../../Lib/Container';
import * as meta from '../../meta-data.json';
import { useStyletron } from '../../Themes';
import { headerRootStyles } from './styles';
import { IDummyProps } from './types';
import { Drawer } from '../Drawer';
import ShortcutsListDrawer from '../../Lib/KeyboardShortcuts/ui/ShortcutsListDrawer';
import { AppSwitcher } from '../AppSwitcher';
import LeftContainer from './components/LeftContainer';
import RightContainer from './components/RightContainer';

const HeaderContainer = ({ className, children, backgroundColor, zIndex, ...rest }: IDummyProps) => {
	const [css]: any = useStyletron();
	let cssClass = css(headerRootStyles({ backgroundColor, zIndex }));
	if (className) {
		cssClass = css(headerRootStyles({ backgroundColor, zIndex })) + ' ' + className;
	}

	return (
		<header data-epo={`epo-header-${meta.version}`} className={cssClass} {...rest}>
			{children}
		</header>
	);
};

const DrawerContainer = (props: {
	activeKeyDrawer: any;
	activeKey: string;
	onKeyboardShortcutClick: any;
	onCloseClick: any;
	children: React.ReactNode;
}) => {
	const { activeKeyDrawer, activeKey, onCloseClick, children } = props;

	return (
		<Drawer
			autoFocus={true} // todo-a11y: improve autofocus > first relevant UI-control instead of close icon ?
			className="drawer"
			showBackdrop={false}
			anchor="right"
			// size="compact"
			isOpen={activeKeyDrawer[activeKey]}
			// todo-a11y: to close ESC needs to be pressed twice, should only be pressed once
			onClose={() => {
				onCloseClick();
			}}
			offset="75px"
			noLateralMargins
			zIndex={1}
		// todo-a11y: dynamic aria-labeling for <aside> depending on children content > help / shortcut manager
		// todo-a11y: sections for children content?  > https://www.w3.org/WAI/ARIA/apg/example-index/landmarks/region.html
		>
			<div className="d-flex flex-column h-100" style={({ width: '400px', paddingTop: '40px' })}>
				<div className="flex-grow-1 scrollable-y">
					{children}
				</div>
			</div>
		</Drawer>
	);
};

export const View = (props: IDummyProps) => {
	const {
		epoLogo,
		epoLogoSrcPath,
		epoLogoTargetUrl,
		onClickEpoLogo,
		hamburgerMenu,
		onHamburgerMenu,
		neutralLogo,
		productName,
		onClickProductName,
		leftLayout,
		rightLayout,
		search,
		onSearchType,
		searchButton,
		connectivityStatus,
		languageSelector,
		voiceCommand,
		onClickVoiceCommand,
		themeSwitch,
		onThemeSwitch,
		secondWindow,
		keyboardShortcut,
		onClickKeyboardShortcut,
		settings,
		help,
		globalNavigation,
		onClickSearchButton,
		onClickConnectivityStatus,
		onClickSecondWindow,
		onClickHelp,
		onClickGlobalNavigation,
		customUtilities,
		username,
		onClickAvatar,
		onClickLanguageSelector,
		onClickSettings,
		backgroundColor = 'var(--epods--color-bg)',
		loggedInUser,
		...rest
	} = props;

	// TODO: After defining behavior the initial state will most likely be an input (REVIEW)
	const defaultConfig = {
		keyboardShortcuts: false,
		settings: false,
		help: false,
		userProfile: false,
		globalNavigation: false,
	};

	const [activeKeyDrawer, setActiveKeyDrawer] = useState(defaultConfig);
	const [activeKey, setActiveKey] = useState('create');
	const [size, setSize] = useState(0);

	const handleKeyboardShortcutsClick = () => {
		setActiveKey('keyboardShortcuts');
		setActiveKeyDrawer({ ...activeKeyDrawer, keyboardShortcuts: true });
	};

	const handleDrawerClose = () => {
		setActiveKeyDrawer({ ...activeKeyDrawer, [activeKey]: false });
	};

	return (
		<Container
			definition={[]}
			onChange={(_vars: any, _size: any) => {
				setSize(_size);
			}}
		>
			<HeaderContainer backgroundColor={backgroundColor} {...rest}>
				<LeftContainer
					leftLayout={leftLayout}
					hamburgerMenu={hamburgerMenu}
					epoLogo={epoLogo}
					neutralLogo={neutralLogo}
					size={size}
					productName={productName}
					onHamburgerMenu={onHamburgerMenu}
					onClickEpoLogo={onClickEpoLogo}
					epoLogoSrcPath={epoLogoSrcPath}
					epoLogoTargetUrl={epoLogoTargetUrl}
					onClickProductName={onClickProductName} />
				{/* todo-a11y: check if aria-label is required when tooltip is available */}
				<RightContainer
					rightLayout={rightLayout}
					search={search}
					onSearchType={onSearchType}
					customUtilities={customUtilities}
					searchButton={searchButton}
					onClickSearchButton={onClickSearchButton}
					connectivityStatus={connectivityStatus}
					onClickConnectivityStatus={onClickConnectivityStatus}
					languageSelector={languageSelector}
					onClickLanguageSelector={onClickLanguageSelector}
					voiceCommand={voiceCommand}
					onClickVoiceCommand={onClickVoiceCommand}
					themeSwitch={themeSwitch}
					onThemeSwitch={onThemeSwitch}
					secondWindow={secondWindow}
					onClickSecondWindow={onClickSecondWindow}
					keyboardShortcut={keyboardShortcut}
					onClickKeyboardShortcut={onClickKeyboardShortcut}
					settings={settings}
					onClickSettings={onClickSettings}
					help={help}
					onClickHelp={onClickHelp}
					globalNavigation={globalNavigation}
					onClickGlobalNavigation={onClickGlobalNavigation}
					username={username}
					onClickAvatar={onClickAvatar}
					setActiveKeyDrawer={setActiveKeyDrawer}
					setActiveKey={setActiveKey}
				/>
			</HeaderContainer>
			{activeKey === 'keyboardShortcuts' && <ShortcutsListDrawer
				offset='65px'
				isOpen={activeKey === 'keyboardShortcuts'}
				showBackdrop={false}
				onCloseShorcuts={() => {
					setActiveKey('create');
				}} />}
			{(activeKey === 'settings' || activeKey === 'help' || activeKey === 'globalNavigation') &&
				<DrawerContainer
					activeKeyDrawer={activeKeyDrawer}
					activeKey={activeKey}
					onKeyboardShortcutClick={handleKeyboardShortcutsClick}
					onCloseClick={handleDrawerClose}
				>
					{activeKey === 'settings' && (
						<h2 id="aside-label" className="h1">
							Settings
						</h2>
					)}
					{activeKey === 'help' && (
						<h2 id="aside-label" className="h1 pl-m">
							Help
						</h2>
					)}
					{activeKey === 'globalNavigation' && <AppSwitcher items={loggedInUser} />}
				</DrawerContainer>}
		</Container >
	);
};

export const SubHeaderContainer = (props: any) => {
	const [css]: any = useStyletron();
	const { size = 'default' } = props;
	const _size: any = {
		mini: '35px',
		compact: '45px',
		default: '55px',
		large: '65px',
	};
	return (
		<div
			className={`${css({
				backgroundColor: 'var(--epods--color-bg-heading)',
				borderBottom: '1px solid var(--epods--color-border-light)',
				height: _size[size],
				display: 'flex',
				alignItems: 'center',
			})} ${props.className} `}
		>
			{props.children}
		</div>
	);
};
